import { EncodeParam, getTokenDetail } from "../../helpers/helper";
import Breadcrumb from "Components/Common/Breadcrumb";
import CustomDataTable from "Components/Shared/CustomDataTable";
import { CustomDropdown } from "Components/Shared/CustomDropdown";
import { CustomSingleCheckbox } from "Components/Shared/CustomsSingleSelect";
import { IColumnModel } from "Models/IColumnModel";
import { IOrderHistorySearchModel } from "Models/IOrderHistorySearchModel";
import CommonService from "Services/CommonService";
import FileSaver from "file-saver";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row, Button } from "reactstrap";
import { forkJoin } from "rxjs";
import { useFormik } from "formik";
import './OrderHistoryStyle.css'
import { Role } from "Components/constants/PandaConstants";
import { CustomDatePicker } from "Components/Shared/CustomDatePicker";
import moment from "moment";
import { Loader } from "Components/Loader/Loader";
import { saveDeliveryDateHandler } from "slices/thunk";
import { useDispatch } from "react-redux";
import LabelPrintComponent from "./LabelPrintComponent";

const OrderHistoryDashBoard = () => {
    const [orderhistory, setOrderhistory] = useState<any>([]);
    const [search, setSearch] = useState("");
    const [totalRowsCount, setTotalRowsCount] = useState<any>();
    const [isPageNumber, setIsPageNumber] = useState<any>();
    const [selectedMenuIds, setSelectedMenuIds] = useState<any>(1);
    const [hidden, setHidden] = useState(false);
    const [loader, setLoader] = useState(true);
    const [menuMaster, setMenuMaster] = useState<any>([]);
    const [restaurantMaster, setRestaurantMaster] = useState<any>([]);
    const [pickupaddressMaster, setPickupaddressMaster] = useState<any>([])
    const [statusEntityMaster, setStatusEntityMaster] = useState<any>([]);
    const [userMaster, setUserMaster] = useState<any>([]);
    const [isRestaurant, setIsRestaurant] = useState(false);
    const [pdfBase64, setPDFBase64] = useState();
    const [roleId, setRoleId] = useState(0);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [restaurentId, setRestaurentId] = useState<any>();
    const dispatch: any = useDispatch();
    const [responseData, setResponseData] = useState(null);
    const [filterDetails, setFilterDetails] = useState({
        fromDate: '',
        toDate: "",
        userId: "",
        menuId: "",
        statusId: '',
        restaurantId: '',
        pickupAddressId: '',
    });
    document.title = "Order history | Panda GoGoGo ";

    const [dateValues, setDateValues] = useState<{ fromDate: any, toDate: any }>({ fromDate: '', toDate: "" });
    const [rowPerPageValue, setRowPerPageValue] = useState(10);

    const filterHandler = (type: "fromDate" | "toDate" | "userId" | "menuId" | "statusId" | "restaurantId" | "pickupAddressId", val: any, fromDate?: any, toDate?: any) => {
        const updatedFilterDetails = { ...filterDetails };
        if (type === "fromDate" || type === "toDate") {
            updatedFilterDetails.fromDate = fromDate || '';
            updatedFilterDetails.toDate = toDate || '';
        } else {
            updatedFilterDetails[type] = val;
        }
        setFilterDetails(updatedFilterDetails);
        getOrderHistoryBySearch(
            1,
            search,
            validation.values.fromDate,
            validation.values.toDate,
            selectedColumn,
            sortOrder,
            updatedFilterDetails.statusId,
            updatedFilterDetails.userId,
            updatedFilterDetails.menuId,
            updatedFilterDetails.restaurantId,
            updatedFilterDetails.fromDate,
            updatedFilterDetails.toDate,
            rowPerPageValue,
            updatedFilterDetails.pickupAddressId
        );
    }

    const sampledata = [{
        id: 1,
        name: "Today"
    },
    {
        id: 4,
        name: "Tomorrow"
    },
    {
        id: 2,
        name: "This week"
    }, {
        id: 3,
        name: "This month"
    },
    ]

    let navigate = useNavigate();
    const AdminColumns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Order Id',
            accessor: 'formattedOrderId',
            width: "17%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'User Name',
            accessor: 'userName',
            width: "15%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'Menu',
            accessor: 'menuName',
            width: "15%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'Status',
            accessor: 'externalStatus',
            width: "15%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'Amount ($)',
            accessor: 'amount',
            width: "12%",
            displayInList: true,
            Filter: true,
            sortable: true,
        },
        {
            Header: 'Order Date',
            accessor: 'created',
            datatype: 'date',
            width: "15%",
            displayInList: true,
            Filter: true,
            sortable: true,
        },
        {
            Header: 'Delivery Date',
            accessor: 'deliveryDate',
            datatype: 'date',
            width: "35%",
            displayInList: true,
            Filter: true,
            sortable: true,
        },
        {
            Header: 'Id',
            accessor: 'id',
            Filter: true,
            sortable: true,
            displayInList: false,
            width: "0%"
        },
    ], []);

    const columns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Order Id',
            accessor: 'formattedOrderId',
            width: "12%",
            displayInList: true,
            Filter: true,
        }, {
            Header: 'User Name',
            accessor: 'userName',
            width: "12%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'Restaurant',
            accessor: 'restaurentName',
            width: "12%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Menu Name',
            accessor: 'menuName',
            width: "12%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Pickup Location',
            accessor: 'pickupAddress',
            width: "12%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Status',
            accessor: 'externalStatus',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Amount ($)',
            accessor: 'amount',
            width: "10%",
            displayInList: true,
            Filter: true,
            sortable: true,
            datatype: 'freeAmount'
        },
        {
            Header: 'Ordered Date',
            accessor: 'created',
            datatype: 'date',
            width: "10%",
            displayInList: true,
            Filter: true,
            sortable: true,
        },
        {
            Header: 'Delivery Date',
            accessor: 'deliveryDate',
            datatype: 'date',
            width: "10%",
            displayInList: true,
            Filter: true,
            sortable: true,
        },
        {
            Header: 'Id',
            accessor: 'id',
            Filter: true,
            displayInList: false,
            width: "0%"
        },
    ], []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: "",
            toDate: "",
            userId: "",
            menuId: "",
            statusId: '',
            restaurentId: '',
            pickupAddressId: '',
        },
        onSubmit: () => {
            setHidden(false);
            getOrderHistoryBySearch(
                1,
                search,
                validation.values.fromDate,
                validation.values.toDate,
                selectedColumn,
                sortOrder,
                filterDetails.statusId,
                filterDetails.userId,
                filterDetails.menuId,
                filterDetails.restaurantId,
                filterDetails.fromDate,
                filterDetails.toDate,
                rowPerPageValue,
                filterDetails.pickupAddressId
            );
        }
    });

    const pagination = (pageNumber: any) => {
        getOrderHistoryBySearch(
            pageNumber,
            search,
            validation.values.fromDate,
            validation.values.toDate,
            selectedColumn,
            sortOrder,
            filterDetails.statusId,
            filterDetails.userId,
            filterDetails.menuId,
            filterDetails.restaurantId,
            filterDetails.fromDate,
            filterDetails.toDate,
            rowPerPageValue,
            filterDetails.pickupAddressId
        );
    }

    const searchHandler = (searchKeyword: any) => {
        setSearch(searchKeyword);
        getOrderHistoryBySearch(
            1,
            searchKeyword,
            validation.values.fromDate,
            validation.values.toDate,
            selectedColumn,
            sortOrder,
            filterDetails.statusId,
            filterDetails.userId,
            filterDetails.menuId,
            filterDetails.restaurantId,
            filterDetails.fromDate,
            filterDetails.toDate,
            rowPerPageValue,
            filterDetails.pickupAddressId
        );
    }

    const onColumnSortChange = (columnName, sortorder) => {
        setSelectedColumn(columnName);
        setSortOrder(sortorder);
        getOrderHistoryBySearch(
            1,
            search,
            validation.values.fromDate,
            validation.values.toDate,
            columnName,
            sortorder,
            filterDetails.statusId,
            filterDetails.userId,
            filterDetails.menuId,
            filterDetails.restaurantId,
            filterDetails.fromDate,
            filterDetails.toDate,
            rowPerPageValue,
            filterDetails.pickupAddressId
        );
    };

    const handleFilter = (value) => {
        dateClearHandler();
        setSelectedMenuIds(value);
        let fromDates = "";
        let toDates = "";
        const date = new Date();
        const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
        if (value == 1) {
            validation.setFieldValue("fromDate", formatDate(date));
            validation.setFieldValue("toDate", formatDate(date));
            fromDates = formatDate(date);
            toDates = formatDate(date);
        } else if (value == 2) {
            const currentDate = new Date(date);
            const dayOfWeek = currentDate.getDay();
            const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
            const monday = new Date(currentDate);
            monday.setDate(currentDate.getDate() + daysToMonday);
            const sunday = new Date(monday);
            sunday.setDate(monday.getDate() + 6);
            validation.setFieldValue("fromDate", formatDate(monday));
            validation.setFieldValue("toDate", formatDate(sunday));
            fromDates = formatDate(monday);
            toDates = formatDate(sunday);
        } else if (value == 3) {
            const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
            const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            validation.setFieldValue("fromDate", formatDate(firstDayOfMonth));
            validation.setFieldValue("toDate", formatDate(lastDayOfMonth));
            fromDates = formatDate(firstDayOfMonth);
            toDates = formatDate(lastDayOfMonth);
        }
        else if (value == 4) {
            const tomorrowNextDay = new Date(new Date().setDate(new Date().getDate() + 1));
            validation.setFieldValue("fromDate", formatDate(tomorrow));
            validation.setFieldValue("toDate", formatDate(tomorrowNextDay));
            fromDates = formatDate(tomorrow);
            toDates = formatDate(tomorrowNextDay);
        }
        dispatch(saveDeliveryDateHandler({ startDate: fromDates, endDate: toDates }));
        filterHandler("fromDate", fromDates, fromDates, toDates);
    }

    const formatDate = (date) => {
        return moment.utc(date).format('YYYY-MM-DD');
        // const utcDate = new Date(date);
        // utcDate.setMinutes(utcDate.getMinutes() + utcDate.getTimezoneOffset());

        // const year = utcDate.getUTCFullYear();
        // const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
        // const day = String(utcDate.getUTCDate()).padStart(2, '0');

        // return `${year}-${month}-${day}`;
    };

    const editHandler = (val: any) => {
        let encodedId = EncodeParam(val.id)
        navigate(`/order/view/${encodedId}`);
    }

    const dateClearHandler = () => {
        dateValues.fromDate = "";
        dateValues.toDate = "";
        filterDetails.fromDate = "";
        filterDetails.toDate = "";
    }

    const rowPerPageHandler = (val) => {
        setRowPerPageValue(val);
        getOrderHistoryBySearch(
            1,
            search,
            validation.values.fromDate,
            validation.values.toDate,
            selectedColumn,
            sortOrder,
            filterDetails.statusId,
            filterDetails.userId,
            filterDetails.menuId,
            filterDetails.restaurantId,
            filterDetails.fromDate,
            filterDetails.toDate,
            val,
            filterDetails.pickupAddressId
        );
    }

    const clear = () => {
        const date = new Date();
        // validation.resetForm();
        // getOrderHistoryBySearch(1, "", validation.values.fromDate, validation.values.toDate);
        filterDetails.fromDate = formatDate(date);
        filterDetails.toDate = formatDate(date);
        filterDetails.menuId = "";
        filterDetails.statusId = "";
        filterDetails.userId = "";
        filterDetails.restaurantId = "";
        filterDetails.pickupAddressId = "";
        setFilterDetails({ ...filterDetails });
        setDateValues({ fromDate: '', toDate: '' });
        setSearch("");
        validation.setFieldValue("universityId", "");
        setSelectedMenuIds(1);
        getOrderHistoryBySearch(
            1,
            "",
            validation.values.fromDate,
            validation.values.toDate,
            null,
            null,
            filterDetails.statusId,
            filterDetails.userId,
            filterDetails.menuId,
            filterDetails.restaurantId,
            filterDetails.fromDate,
            filterDetails.toDate,
            rowPerPageValue,
            filterDetails.pickupAddressId
        );
        dispatch(saveDeliveryDateHandler({ startDate: formatDate(date), endDate: formatDate(date) }));
    }

    const HandlePrint = async (
        pagenumber: any,
        searchText: string,
        fromDate: string,
        toDate: string,
        sortcolumn?: any,
        sortorder?: any,
        statusId?: any,
        userId?: any,
        menuId?: any,
        FilteredrestaurantId?: any,
        startDate?: any,
        endDate?: any,
        rowPerPageVal?: any,
        pickupaddressId?: any
    ) => {
        try {
            setLoader(true);
            const token: any = getTokenDetail();
            const roleIdValue = parseInt(token.RoleId, 10);
            const restaurantId = localStorage.getItem("restaurentId");

            const searchModel: IOrderHistorySearchModel = {
                offsetStart: pagenumber,
                rowsPerPage: rowPerPageVal || rowPerPageValue,
                sortOrder: sortorder || "DESC",
                searchText: searchText || "",
                sortColumn: sortcolumn || "formattedorderid",
                userId: userId ? userId : null,
                statusId: statusId ? statusId : null,
                menuId: menuId ? menuId : null,
                pickupaddressId: pickupaddressId ? pickupaddressId : null,
                restaurentId:
                    roleIdValue === Role.Admin
                        ? restaurantId
                        : FilteredrestaurantId
                            ? FilteredrestaurantId
                            : null,
                startDate: startDate || null,
                endDate: endDate || null,
            };
            // const res = await CommonService.post("UserOrder", "GetOrderPDFList", searchModel);

            // if (res.status === 200 && res.data?.responseData?.pdfBase64) {
            //     let base64 = res.data.responseData.pdfBase64;
            //     base64 = base64.replace(/\\r\\n/g, '').replace(/\n/g, '').replace(/\r/g, '').trim();
            //     const byteCharacters = atob(base64);
            //     const byteNumbers = new Array(byteCharacters.length);
            //     for (let i = 0; i < byteCharacters.length; i++) {
            //         byteNumbers[i] = byteCharacters.charCodeAt(i);
            //     }
            //     const byteArray = new Uint8Array(byteNumbers);
            //     const blob = new Blob([byteArray], { type: "application/pdf" });
            //     const blobUrl = URL.createObjectURL(blob);
            //     window.open(blobUrl, "_blank");
            // }
            const res = await CommonService.post("UserOrder","GetOrderViews",searchModel)
            if (res.status === 200) {
            setResponseData(res.data.responseData); 
            }
            else {
                alert("No PDF found.");
            }
        } catch (err) {
            console.error("Error fetching PDF:", err);
        } finally {
            setLoader(false);
        }
    };
    const DownloadCSV = () => {
        let data: IOrderHistorySearchModel = {
            offsetStart: 1,
            rowsPerPage: totalRowsCount,
            sortOrder: sortOrder || "Desc",
            searchText: search || "",
            sortColumn: selectedColumn || "deliveryDate",
            userId: filterDetails.userId ? filterDetails.userId : null,
            statusId: filterDetails.statusId ? filterDetails.statusId : null,
            menuId: filterDetails.menuId ? filterDetails.menuId : null,
            restaurentId: roleId == Role.Admin ? restaurentId : null,
            startDate: filterDetails.fromDate || null,
            endDate: filterDetails.toDate || null,
            pickupaddressId: filterDetails.pickupAddressId ? filterDetails.pickupAddressId : null,
        }
        CommonService.post("UserOrder", "ExportOrderViewCsv", data).then(
            (res) => {
                if (res.status === 200) {
                    const csvContent = atob(res.data);
                    const blob = new Blob([csvContent], { type: "data:application/octet-stream;base64" });
                    const file = new File([blob], `PandaGoGoGo_OrderHistory_Report.csv`, { type: "data:application/octet-stream;base64" });
                    FileSaver.saveAs(file);
                }
            },
            (error) => {
                console.error('Error occurred:', error);
            }
        );
    }

    const getOrderHistoryBySearch = (
        pagenumber: any,
        searchText: string,
        fromDate: string,
        toDate: string,
        sortcolumn?: any,
        sortorder?: any,
        statusId?: any,
        userId?: any,
        menuId?: any,
        FilteredrestaurantId?: any,
        startDate?: any,
        endDate?: any,
        rowPerPageVal?: any,
        pickupaddressId?: any
    ) => {
        setLoader(true);
        let token: any = getTokenDetail();
        let roleIdValue = parseInt(token.RoleId, 10);
        let restaurantId = localStorage.getItem("restaurentId");
        setRestaurentId(restaurantId);
        let searchModel: IOrderHistorySearchModel = {
            offsetStart: pagenumber,
            rowsPerPage: rowPerPageVal || rowPerPageValue,
            sortOrder: sortorder || "DESC",
            searchText: searchText || "",
            sortColumn: sortcolumn || "formattedorderid",
            userId: userId ? userId : null,
            statusId: statusId ? statusId : null,
            menuId: menuId ? menuId : null,
            pickupaddressId: pickupaddressId ? pickupaddressId : null,
            restaurentId: roleIdValue == Role.Admin ? restaurantId : FilteredrestaurantId ? FilteredrestaurantId : null,
            startDate: startDate || null,
            endDate: endDate || null
        }
        dispatch(saveDeliveryDateHandler({ startDate: startDate ? formatDate(startDate) : null, endDate: endDate ? formatDate(endDate) : null }));
        CommonService.post("UserOrder", "GetOrderViews", searchModel).then(res => {
            if (res.status == 200) {
                let data = res.data.responseData;
                setOrderhistory(data);
                setIsPageNumber(pagenumber);
                setTotalRowsCount(res.data.responseData[0]?.totalRowsCount);
                setLoader(false);
            }
        });
    }

    useEffect(() => {
        const date = new Date();
        validation.setFieldValue("fromDate", formatDate(date));
        validation.setFieldValue("toDate", formatDate(date));
        let token: any = getTokenDetail();
        let roleIdValue = parseInt(token.RoleId, 10);
        filterDetails.fromDate = formatDate(date);
        filterDetails.toDate = formatDate(date);
        setRoleId(roleIdValue);
        if (roleIdValue == Role.Admin) {
            setIsRestaurant(true);
        }
        let status = CommonService.getWithQueryParam("Status", "GetStatusByEntityName", "EntityName", "Order");
        let restaurantId = localStorage.getItem("restaurentId");
        if (roleIdValue == Role.SuperAdmin) {
            var menu = CommonService.get("Menu", "GetAllMenu");
            var user = CommonService.getWithQueryParam("User", "GetAllUserByUserRoleId", "userRoleId", Role.User);
            var restaurant = CommonService.get("Masters", "GetRestaurentMaster");
            var pickupaddress = CommonService.get("PickupAddress", "GetAllPickupAddress");
            forkJoin({ menu, status, user, restaurant, pickupaddress }).subscribe((res: { menu: any, status: any, user: any, restaurant: any, pickupaddress: any }) => {
                setRestaurantMaster(res.restaurant.data.responseData.restaurentList);
                setMenuMaster(res.menu.data.responseData);
                setPickupaddressMaster(res.pickupaddress.data.responseData);
                const uniques = res.user?.data?.responseData?.filter((value, index, self) =>
                    index == self.findIndex((t) => (
                        t.id == value.id
                    )));
                setUserMaster(uniques);
                const filteredStatus = res.status.data.responseData?.filter(status => status.name == "Order Delivered" || status.name == "Pending");
                setStatusEntityMaster(filteredStatus);
            });
        } else if (roleIdValue == Role.Admin) {
            var menu = CommonService.getWithQueryParam("Menu", "GetMenuByRestaurentId", "restaurentId", restaurantId);
            var user = CommonService.getWithDoubleQueryParam("User", "GetAllUserByRestaurentId", "userRoleId", Role.User, "restaurentId", restaurantId);
            var restaurant = CommonService.get("Masters", "GetRestaurentMaster");
            var pickupaddress = CommonService.get("PickupAddress", "GetAllPickupAddress");
            forkJoin({ menu, status, user, restaurant,pickupaddress }).subscribe((res: { menu: any, status: any, user: any, restaurant: any, pickupaddress: any }) => {
                setRestaurantMaster(res.restaurant.data.responseData.restaurentList);
                setMenuMaster(res.menu.data.responseData);
                setPickupaddressMaster(res.pickupaddress.data.responseData);
                const uniques = res.user?.data?.responseData?.filter((value, index, self) =>
                    index == self.findIndex((t) => (
                        t.id == value.id
                    )));
                setUserMaster(uniques);
                const filteredStatus = res.status.data.responseData?.filter(status => status.name == "Order Delivered" || status.name == "Pending");
                setStatusEntityMaster(filteredStatus);
            });
        }
        dispatch(saveDeliveryDateHandler({ startDate: formatDate(date), endDate: formatDate(date) }));
        getOrderHistoryBySearch(
            1,
            "",
            validation.values.fromDate,
            validation.values.toDate,
            null,
            null,
            filterDetails.statusId,
            filterDetails.userId,
            filterDetails.menuId,
            filterDetails.restaurantId,
            formatDate(date),
            formatDate(date),
            rowPerPageValue,
            filterDetails.pickupAddressId
        );
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Breadcrumb title="Order History" breadcrumbItem="Order-History" breadcrumbTitle={"Dashboard"}
                    breadcrumbTitlePath={"/dashboard"} breadcrumbItemPath={"/orderhistory"} />
                <Card>
                    <CardBody>
                        <Row>
                            {!isRestaurant &&
                                <Col lg={isRestaurant ? 4 : 4} className="mb-3">
                                    <CustomDropdown
                                        label="Restaurant" id="restaurantId"
                                        data={restaurantMaster}
                                        value={filterDetails.restaurantId }
                                        onChange={(e) => { filterHandler("restaurantId", e.target.value); }}
                                        placeholder="Restaurant"
                                        name="Restaurant Name"
                                        isMandatory={false}
                                        error={validation.errors.restaurentId}
                                        touched={validation.touched.restaurentId}
                                        displayField="displayName"
                                        valueField="encryptedId" onBlur={undefined} invalid={undefined} />
                                </Col>
                            }
                            <Col lg={isRestaurant ? 4 : 4} className="mb-3">
                                <CustomDropdown
                                    label="Menu" id="menuId"
                                    data={menuMaster}
                                    value={filterDetails.menuId}
                                    onChange={(e) => { filterHandler("menuId", e.target.value); }}
                                    placeholder="Menu"
                                    name="Menu Name"
                                    isMandatory={false}
                                    error={validation.errors.menuId}
                                    touched={validation.touched.menuId}
                                    displayField="displayName"
                                    valueField="id" onBlur={undefined} invalid={undefined} />
                            </Col>
                            <Col lg={isRestaurant ? 4 : 4} className="mb-3">
                                <CustomDropdown
                                    label={"Status"}
                                    id={"statusId"}
                                    data={statusEntityMaster}
                                    value={filterDetails.statusId}
                                    onChange={(e) => filterHandler("statusId", e.target.value)}
                                    onBlur={validation.handleBlur}
                                    error={validation.errors.statusId}
                                    invalid={validation.touched.statusId && validation.errors.statusId ? true : false}
                                    touched={validation.touched.statusId}
                                    valueField={"id"}
                                    displayField={"externalStatus"} />
                            </Col>
                            <Col lg={isRestaurant ? 4 : 4} className="mb-3">
                                <CustomDropdown
                                    label="User Name" id="userId"
                                    data={userMaster.map(user => ({
                                        ...user,
                                        fullName: `${user.firstName} ${user.lastName}`
                                    }))}
                                    value={filterDetails.userId}
                                    onChange={(e) => { filterHandler("userId", e.target.value); }}
                                    placeholder="User Name"
                                    name="User Name"
                                    isMandatory={false}
                                    error={validation.errors.userId}
                                    touched={validation.touched.userId}
                                    displayField="fullName"
                                    valueField="id" onBlur={undefined} invalid={undefined} />
                            </Col>
                            <Col lg={4} className="mb-3">
                                <CustomDatePicker
                                    label={"Delivery From"}
                                    id={undefined}
                                    value={moment(dateValues.fromDate).format("YYYY-MM-DD")}
                                    onChange={(e) => { setSelectedMenuIds(0); setDateValues({ ...dateValues, fromDate: e.target.value }); filterHandler("fromDate", e.target.value, e.target.value, dateValues.toDate) }}
                                    error={undefined} />
                            </Col>
                            <Col lg={4} className="mb-3">
                                <CustomDatePicker
                                    label={"Delivery To"}
                                    id={undefined}
                                    disabled={!dateValues.fromDate}
                                    minDate={moment(dateValues.fromDate).format("YYYY-MM-DD")}
                                    value={moment(dateValues.toDate).format("YYYY-MM-DD")}
                                    onChange={(e) => { setSelectedMenuIds(0); setDateValues({ ...dateValues, toDate: e.target.value }); filterHandler("toDate", e.target.value, dateValues.fromDate, e.target.value) }}
                                    error={undefined} />
                            </Col>
                            <Col lg={isRestaurant ? 4 : 4} className="mb-3">
                                <CustomDropdown
                                    label="pickupAddress" id="pickupAddressId"
                                    data={pickupaddressMaster}
                                    value={filterDetails.pickupAddressId}
                                    onChange={(e) => { filterHandler("pickupAddressId", e.target.value); }}
                                    placeholder="pickupAddress"
                                    name="name"
                                    isMandatory={false}
                                    error={validation.errors.pickupAddressId}
                                    touched={validation.touched.pickupAddressId}
                                    displayField="name"
                                    valueField="id" onBlur={undefined} invalid={undefined} />
                            </Col>
                            {isRestaurant ?
                                <Col lg={8}>
                                </Col> : <Col lg={4}></Col>}
                            <Col lg={4} className="mt-4 custom-border">
                                <div className="border-label">
                                    <label className="border-label-text">Order Delivery</label>
                                    <CustomSingleCheckbox
                                        label={""}
                                        id={"ids"}
                                        className={"col-6 mb-2 registration-custom-checkbox"}
                                        value={undefined}
                                        onChange={handleFilter}
                                        invalid={undefined}
                                        error={undefined}
                                        data={sampledata}
                                        isHorizontal={true}
                                        selectedValues={selectedMenuIds}
                                        valueField={"id"}
                                        displayField={"name"} />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} style={{ marginTop: "4px" }}>
                                <div className='d-flex justify-content-end'>
                                    <Button
                                        style={{ width: '75px', height: '37px', borderRadius: '5px', border: '1px', padding: '1px 11px 1px 11px' }}
                                        type={"button"}
                                        disabled={
                                            orderhistory.length === 0 ||
                                            !validation.values.fromDate ||
                                            !validation.values.toDate
                                        }
                                        onClick={() => HandlePrint(
                                            1,
                                            search,
                                            validation.values.fromDate,
                                            validation.values.toDate,
                                            selectedColumn,
                                            sortOrder,
                                            filterDetails.statusId,
                                            filterDetails.userId,
                                            filterDetails.menuId,
                                            filterDetails.restaurantId,
                                            filterDetails.fromDate,
                                            filterDetails.toDate,
                                            orderhistory[0].totalRowsCount,
                                            filterDetails.pickupAddressId
                                        )}
                                        className="ms-2 btn btn-success"
                                    >
                                        <i className="mdi mdi-printer cursor-pointer"></i> Print
                                    </Button>
                                    <Button
                                        style={{ width: '75px', height: '37px', borderRadius: '5px', border: '1px', padding: '1px 11px 1px 11px' }}
                                        type={"button"}
                                        onClick={() => clear()}
                                        className="ms-2 btn btn-secondary"
                                    >
                                        Reset
                                    </Button>
                                    {orderhistory.length > 0 && <div onClick={() => DownloadCSV()} style={{ cursor: "pointer" }}>
                                        <i className="ms-3 fa fa-file-excel excel-icon"></i>
                                    </div>}
                                </div>
                            </Col>
                        </Row>
                        <Loader open={loader} />
                        <CustomDataTable
                            rowPerPageValue={rowPerPageValue}
                            rowPerPageHandler={rowPerPageHandler}
                            columns={roleId > 1 ? AdminColumns : columns}
                            data={orderhistory}
                            customPageSize={rowPerPageValue}
                            editHandler={editHandler}
                            canShowButton={false}
                            deleteHandler={undefined}
                            createHandler={undefined}
                            path={""}
                            canView={false}
                            perPageData={rowPerPageValue}
                            isPagination={true}
                            isGlobalFilter={true}
                            canEdit={false}
                            selectedPage={pagination}
                            searchHandler={searchHandler}
                            isAction={false}
                            isShowingPageLength={true}
                            onColumnSortChange={onColumnSortChange}
                        />
                    </CardBody>
                </Card>
                {responseData && (
        <LabelPrintComponent responseData={responseData} onComplete={() => setResponseData(null)} />
      )}
            </div>
        </React.Fragment>
    );
}
export default OrderHistoryDashBoard;